import { render } from "./PerformanceDashboardByResource.vue?vue&type=template&id=589e4280&scoped=true"
import script from "./PerformanceDashboardByResource.vue?vue&type=script&lang=js"
export * from "./PerformanceDashboardByResource.vue?vue&type=script&lang=js"

import "./PerformanceDashboardByResource.vue?vue&type=style&index=0&id=589e4280&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589e4280"]])

export default __exports__
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTab});
